var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowCircledTopRight = function SvgArrowCircledTopRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87853 7.46451C9.32625 7.46451 8.87853 7.91223 8.87853 8.46451C8.87853 9.0168 9.32625 9.46451 9.87853 9.46451L13.1212 9.46451L7.75721 14.8285C7.36669 15.219 7.36669 15.8522 7.75721 16.2427C8.14774 16.6332 8.7809 16.6332 9.17143 16.2427L14.5354 10.8787L14.5354 14.1214C14.5354 14.6737 14.9831 15.1214 15.5354 15.1214C16.0877 15.1214 16.5354 14.6737 16.5354 14.1214L16.5354 8.46451C16.5354 7.91223 16.0877 7.46451 15.5354 7.46451L9.87853 7.46451Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3431 6.34314C3.21891 9.46734 3.21891 14.5327 6.3431 17.6569C9.46729 20.781 14.5326 20.781 17.6568 17.6569C20.781 14.5327 20.781 9.46734 17.6568 6.34315C14.5326 3.21895 9.46729 3.21895 6.3431 6.34314ZM4.92889 4.92893C1.02364 8.83417 1.02364 15.1658 4.92889 19.0711C8.83413 22.9763 15.1658 22.9763 19.071 19.0711C22.9763 15.1658 22.9763 8.83418 19.071 4.92893C15.1658 1.02369 8.83413 1.02369 4.92889 4.92893Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
};
export { SvgArrowCircledTopRight as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-circled-top-right.5dbfa6bb.svg";